'use es6';

import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
import { jsx as _jsx } from "react/jsx-runtime";
import { PureComponent } from 'react';
import classNames from 'classnames';
import emptyFunction from 'react-utils/emptyFunction';
import PropTypes from 'prop-types';
import { pick } from 'underscore';
import FormattedMessage from 'I18n/components/FormattedMessage';
import UIButton from 'UIComponents/button/UIButton';
import UIList from 'UIComponents/list/UIList';
export default class FinderActionsList extends PureComponent {
  renderListChildren({
    actions,
    children,
    handlers,
    i18nKey,
    i18nOptions,
    permissions
  }) {
    if (children) {
      return children;
    }

    return actions.map(actionList => {
      return actionList.map(__actionType => {
        const hasPermission = !!permissions[__actionType];
        const clickHandler = handlers[__actionType] || emptyFunction;
        return /*#__PURE__*/_jsx(UIButton, {
          disabled: !hasPermission,
          onClick: clickHandler,
          use: "link",
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: i18nKey(__actionType),
            options: i18nOptions(__actionType)
          })
        }, __actionType);
      });
    });
  }

  render() {
    const _this$props = this.props,
          {
      actions,
      childClassName,
      children,
      className,
      handlers,
      i18nKey,
      i18nOptions,
      permissions,
      use
    } = _this$props,
          rest = _objectWithoutPropertiesLoose(_this$props, ["actions", "childClassName", "children", "className", "handlers", "i18nKey", "i18nOptions", "permissions", "use"]);

    const listProps = pick(rest, Object.keys(UIList.propTypes));
    const asContextMenu = use === 'contextmenu';
    const renderedChildren = this.renderListChildren({
      actions,
      children,
      handlers,
      i18nKey,
      i18nOptions,
      permissions
    });
    const listClasses = classNames('actions-list', className, asContextMenu && 'context-menu--list');
    const itemClasses = classNames('actions-list__item', childClassName, asContextMenu && 'context-menu--list__item');
    return /*#__PURE__*/_jsx(UIList, Object.assign({}, listProps, {
      childClassName: itemClasses,
      className: listClasses,
      children: renderedChildren
    }));
  }

}
FinderActionsList.displayName = 'FinderActionsList';
FinderActionsList.propTypes = {
  actions: PropTypes.arrayOf(PropTypes.arrayOf(PropTypes.string)),
  childClassName: PropTypes.string,
  children: PropTypes.oneOfType([PropTypes.node, PropTypes.arrayOf(PropTypes.node)]),
  className: PropTypes.string,
  handlers: PropTypes.object,
  i18nKey: PropTypes.func,
  i18nOptions: PropTypes.func,
  permissions: PropTypes.object,
  use: PropTypes.oneOf(['default', 'contextmenu'])
};
FinderActionsList.defaultProps = {
  actions: [],
  childClassName: '',
  children: null,
  className: '',
  handlers: {},
  i18nKey: emptyFunction,
  i18nOptions: emptyFunction,
  permissions: {},
  use: 'default'
};